import { _,$,Backbone,Foundation,moment,Radio } from '../../vendor'
import { Biscuit } from '../utils'
import InboomaBaseController from './InboomaBaseController'

import LinksMap from './ContingentsControllerAccessBarMap'
import Pricetariff from '../models/Pricetariff'

import PricetariffForm from '../views/contingents/PricetariffForm'
import PricetariffsView from '../views/pricetariffs/PricetariffsView'
import PricetariffsSidebarView from '../views/pricetariffs/PricetariffsSidebarView'
import PricetariffsSortTabs from '../views/pricetariffs/PricetariffsSortTabs'
import PricetariffsViewTpl from '../templates/pricetariffs/PricetariffsTpl.html'

export default InboomaBaseController.extend({

    _el: '#inb-c-main-pricetariffs',
    _channelName: 'pricetariffs',
    _template: PricetariffsViewTpl,

    _accessBarMap () {
        return {
            pageTitle: this.t('prices',null,'capital'),
            linksMap: LinksMap()
        }
    },

    index (options) {

        this._resetOptions(options);

        if (!$('.inb-filtered-pricetariffs-count').length) {

            new PricetariffsView({ 
                collection: this._collection,
                el: this.el
            });

            new PricetariffsSidebarView({ collection: this._collection }).render();
            new PricetariffsSortTabs({ collection: this._collection, model: Pricetariff}).render();

            $('.inb-filtered-pricetariffs-count').html(this.collection.models.length);     

        }
        let mainMenu = document.getElementById('inb-main-menu');
        if (mainMenu !== undefined && mainMenu != null && mainMenu.querySelector('.l-contingents')) {
            mainMenu.querySelector('.l-contingents').classList.add('active');
        }
    },

    /**
     * @routes /pricetariffs/[id:int]
     *         /pricetariffs/add
     */
    pricetariffsForm (pId) {

        this.index();

        const model = (typeof pId === 'undefined' || pId === 'add')
                        ? new Pricetariff({
                            client_id : Biscuit.get('user.client_id'),
                            begin : moment().format('YYYY-MM-DD HH:mm'),
                            end :  moment().add(10,'years').format('YYYY-MM-DD HH:mm')            
                        })
                        : this._collection.get(pId);

        const pricetariffForm = new PricetariffForm({
            collection: this._collection,
            contingents: Radio.channel('contingents').request('get:data'),
            pricetypes: Radio.channel('pricetypes').request('get:data'),
            model
        });
  
    },

    /**
     * @routes /pricetariffs/help
     */
    pricetariffsHelp () {

        this.index();

        new Foundation.Reveal($('.inb-pricetariffs-help-modal')).open();

        $(document).on('closed.zf.reveal', function() {
            Backbone.history.navigate('pricetariffs');
            $(document).off('closed.zf.reveal');
        });

    },
});